import { createSlice } from "@reduxjs/toolkit";
import { getPharmacyProducts } from "../../reducer/getPharmacyProducts/getPharmacyProductsReducer";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const getPharmacyProductsSlice = createSlice({
  name: "getPharmacyProducts",
  initialState,
  reducers: {
    clearProductsData: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPharmacyProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPharmacyProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getPharmacyProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearProductsData } = getPharmacyProductsSlice.actions;
export default getPharmacyProductsSlice.reducer;
